import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Switch, Route, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import {Dropdown} from 'semantic-ui-react';
import './LanguageSelector.css';

const LanguageSelector = props => {
  const languages = [
    { key: 1, text: 'فارسی', value: 'rtl/fa-IR' },
    { key: 2, text: 'English', value: 'ltr/en-US' },
    { key: 3, text: 'العربی', value: 'rtl/ar-SA' },
    { key: 4, text: 'Turkish', value: 'ltr/tr-Tr' },
  ];

  const localLanguage = localStorage.getItem('language');
  const defaultLanguage = localLanguage ? localLanguage : 'rtl/fa-IR';

  const onChangeLanguage = (e, { value }) => {
    localStorage.setItem('language', value);
    window.location.reload();
  };

  return (
    <div className={`languageBox ${props.lite ? 'lite' : ''} ${props.mobile ? 'mobile' : ''}`}>
    <Dropdown
      icon="world"
      labeled
      search
      selection
      options={languages}
      defaultValue={defaultLanguage}
      onChange={onChangeLanguage}
    />
    </div>
  )
};

export default LanguageSelector;
